import { render, staticRenderFns } from "./PromotionForm.vue?vue&type=template&id=715b4a36&scoped=true&"
import script from "./PromotionForm.vue?vue&type=script&lang=js&"
export * from "./PromotionForm.vue?vue&type=script&lang=js&"
import style0 from "./PromotionForm.vue?vue&type=style&index=0&id=715b4a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715b4a36",
  null
  
)

component.options.__file = "PromotionForm.vue"
export default component.exports